import React from 'react';
import {FormControl, Select, MenuItem} from '@mui/material';
import {useQuery} from 'react-query';
import ProviderService from '../../../../apis/ProviderService';
import {useHeaderFilter} from './useHeaderFilter';

const ProviderNameSelect = (props) => {
  const getProviderNames = useQuery('getProviderNames', async () => {
      const data = await ProviderService.getAll();
      return data.map(rec => rec.name).sort();
    },
      {
        staleTime: Infinity
      }
  );

  const {handleChange, value} = useHeaderFilter(props);

  return (
    <FormControl variant='standard' fullWidth>
      <Select
        value={value}
        onChange={handleChange}
      >
        {[
            <MenuItem key='' value=''><em>Any</em></MenuItem>,
            ...(getProviderNames.data?.map(providerName => (
              <MenuItem key={providerName} value={providerName}>{providerName}</MenuItem>
            )) ?? [])
        ]}
      </Select>
    </FormControl>
  );
};

export default ProviderNameSelect;